import { useState, useEffect } from "react";

const useEvolution = (name) => {
  const [pokemonData, setPokemonData] = useState(null);
  const [loadingEvol, setLoadingEvol] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!name) {
      return; // no name provided, do nothing
    }

    const controller = new AbortController();

    const fetchPokemon = async () => {
      setLoadingEvol(true);
      setError(null);

      try {
        const response = await fetch(
          `https://pokeapi.co/api/v2/pokemon/${name}`,
          {
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error(`no evolution`);
        }

        const data = await response.json();
        setPokemonData(data);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message);
        }
      } finally {
        setLoadingEvol(false);
      }
    };

    fetchPokemon();

    return () => controller.abort(); // cleanup: abort fetch on unmount or name change
  }, [name]);

  return { pokemonData, loadingEvol, error };
};

export default useEvolution;
